var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vx-input',_vm._g(_vm._b({directives:[{name:"mask",rawName:"v-mask",value:(_vm.abn_mask),expression:"abn_mask"}],model:{value:(_vm.abn),callback:function ($$v) {_vm.abn=$$v},expression:"abn"}},'vx-input',_vm.attrs,false),_vm.listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }